import type { Resume, ResumeFormat } from "@/lib/api/resumeService";
import SheetLayout, { type SheetType } from "@/components/resume/SheetLayout";

/** The PDF's sizes at the sheet's width, about a pixel to a point. */
const TYPE: SheetType = {
    name: "text-[24.5px]",
    headline: "text-[11px]",
    contact: "text-[9.5px]",
    heading: "text-[13.3px]",
    body: "text-[10px]",
    title: "text-[10.5px]",
    detail: "text-[9.5px]",
    leading: "leading-[1.4]",
    gap: "gap-[5px]",
    bulletGap: "gap-0.5",
    bulletIndent: "pl-5 mt-1",
};

/**
 * A resume as the sheet the company was sent: the header centered, then
 * one column, its own type, its sections in its own order. Paper and ink
 * stay light in both themes.
 */
export default function ResumeSheet({ resume, format }: { resume: Resume; format: ResumeFormat }) {
    const family =
        format.typeface === "TIMES"
            ? "'Times New Roman', Times, serif"
            : "Helvetica, Arial, sans-serif";

    return (
        <div
            aria-label="The resume as sent"
            className="mx-auto box-border flex w-full max-w-[560px] flex-col gap-4 rounded-[3px] bg-paper px-12 py-11 text-ink shadow-sheet max-sm:px-6 max-sm:py-7"
            style={{ fontFamily: family }}
        >
            <SheetLayout resume={resume} format={format} name={resume.name} type={TYPE} />
        </div>
    );
}
